import { EmployerAccountTransaction2xx9wct21t09o as EmployerAccountTransaction } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_reason1ql5s15ou11ka as get_reason,
  get_employergdu8c3bkfw8 as get_employer,
  get__id1hi7gtah39onn as get__id,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  xDataClassPathContainsCased3loynnz3n7tb9 as xDataClassPathContainsCased,
  eq353yrgcpovoi1 as eq,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  None_instance1vdtnxdfytk8h as None_instance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  Semanticpmpmvt7fldq2 as Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { DangerTextSemantic_getInstancetznd91yayzn7 as DangerTextSemantic_getInstance } from '../../theme/semantics.mjs';
import {
  _Cents___init__impl__6gjhxu21pac6t02ivb3 as _Cents___init__impl__6gjhxu,
  Cents__compareTo_impl_jg87bs1a0ekdl2mvgbq as Cents__compareTo_impl_jg87bs,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  toDuration28gf6ughsr3vf as toDuration_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  IDqqik72jjbpsn as ID,
  Employer27b20p5x27kte as Employer,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  EmployerTransactionFiltersoi92a4xu2zce as EmployerTransactionFilters,
  employerTransactionFiltersizt17werjvgn as employerTransactionFilters,
  employerTransactionFilterChips25clpsu7zf0i2 as employerTransactionFilterChips,
} from './EmployerTransactionFilters.mjs';
import { And1a3dbpwh0hxmu as And } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from '../components/search.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  exportButton1ekt3fxzrhh34 as exportButton,
} from '../components/view-utilities.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tableRecycler3rsrjjwywx3ie as tableRecycler,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { applyAlpha3k2fcxahu1lgz as applyAlpha } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function EmployerTransactionsPage$searchCondition$lambda$lambda(word) {
  // Inline function 'com.lightningkite.services.database.condition' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$2);
  return xDataClassPathContainsCased(get_reason(it), word, true);
}
function EmployerTransactionsPage$render$lambda$slambda(this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.searchCondition_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var rows = yield* tmp.fetchAll_tffaak_k$(tmp_0, tmp$ret$1, $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_1.serializer_9w0wvi_k$()), rows);
    var tmp_1 = $this_exportButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.employer_1;
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    yield* download(tmp_1, tmp$ret$2.name_1 + ' transactions.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function EmployerTransactionsPage$render$lambda($this$tableRecycler, it) {
  return $this$tableRecycler;
}
function EmployerTransactionsPage$render$lambda_0($this$custom) {
  return 'Date';
}
function EmployerTransactionsPage$render$lambda_1($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed($this$custom, ($this$dynamicThemed) => !($this$dynamicThemed.invoke_r7m7el_k$(it).voided_1 == null) ? StrikeRowSemantic_getInstance() : None_instance);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(it).at_1, RenderSize_Abbreviation_getInstance()));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function EmployerTransactionsPage$render$lambda_2($this$custom) {
  return 'Reason';
}
function EmployerTransactionsPage$render$lambda_3($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed($this$custom, ($this$dynamicThemed) => !($this$dynamicThemed.invoke_r7m7el_k$(it).voided_1 == null) ? StrikeRowSemantic_getInstance() : None_instance);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(it).reason_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function EmployerTransactionsPage$render$lambda_4($this$custom) {
  return 'Voided';
}
function EmployerTransactionsPage$render$lambda_5($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed($this$custom, LabelGapSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    var v = $this$invoke.invoke_r7m7el_k$(it).voided_1;
    var tmp1_elvis_lhs = v == null ? null : v.reason_1;
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  });
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
    var v = $this$invoke.invoke_r7m7el_k$(it).voided_1;
    return !(v == null) ? 'Voided ' + renderToString(v.at_1, RenderSize_Abbreviation_getInstance()) : '';
  });
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function EmployerTransactionsPage$render$lambda_6($this$custom) {
  return 'Amount';
}
function EmployerTransactionsPage$render$lambda_7($this$custom, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = get_bold(dynamicThemed($this$custom, ($this$dynamicThemed) => !($this$dynamicThemed.invoke_r7m7el_k$(it).voided_1 == null) ? StrikeRowSemantic_getInstance() : Cents__compareTo_impl_jg87bs($this$dynamicThemed.invoke_r7m7el_k$(it).amount_1, _Cents___init__impl__6gjhxu(0n)) < 0 ? DangerTextSemantic_getInstance() : None_instance));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => (Cents__compareTo_impl_jg87bs($this$invoke.invoke_r7m7el_k$(it).amount_1, _Cents___init__impl__6gjhxu(0n)) > 0 ? '+' : '-') + Cents__toString_impl_ko5hxm($this$invoke.invoke_r7m7el_k$(it).amount_1));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function EmployerTransactionsPage$render$lambda_8($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var EmployerTransactionsPageClass;
function EmployerTransactionsPage() {
  if (EmployerTransactionsPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.employer_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$();
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$0 = toDuration(5, DurationUnit_MINUTES_getInstance());
          return $this$remember.awaitNotNull_2lqt5h_k$(tmp.item$default_6j9a06_k$(new (ID())(this.id_1), tmp$ret$0));
        });
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp_0 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        var tmp$ret$1 = toDuration_0(0.25, DurationUnit_SECONDS_getInstance());
        tmp_0.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$1, get_AppScope());
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (EmployerTransactionFilters())());
        var tmp_1 = this;
        tmp_1.searchCondition_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(EmployerAccountTransaction()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          var tmp_0 = eq(get_employer(it), new (ID())(this.id_1));
          var tmp_1 = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          return And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([tmp_0, textSearchCondition(tmp_1, EmployerTransactionsPage$searchCondition$lambda$lambda), $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]);
        });
        var tmp_2 = this;
        tmp_2.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employerAccountTransactions_7pvrwe_k$();
          var tmp_0 = new (Query())($this$remember.invoke_r7m7el_k$(this.searchCondition_1), VOID, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$7 = toDuration(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$7);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.employer_1).name_1 + ' \u2014 Employer transactions');
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = weight(this_3, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_4.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_1);
        searchField(element_0, this.textSearch_1);
        employerTransactionFilters(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export employer transactions', VOID, VOID, VOID, VOID, VOID, EmployerTransactionsPage$render$lambda$slambda(this, $this$exportButton)));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        employerTransactionFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_2 = weight(element, 1.0);
        var tmp_3 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_4 = EmployerTransactionsPage$render$lambda;
        var tmp_5 = Companion_instance_0;
        var tmp_6 = EmployerTransactionsPage$render$lambda_0;
        var tmp_7 = tmp_5.custom_k0krgj_k$(tmp_6, 0.7, EmployerTransactionsPage$render$lambda_1);
        var tmp_8 = Companion_instance_0;
        var tmp_9 = EmployerTransactionsPage$render$lambda_2;
        var tmp_10 = tmp_8.custom_k0krgj_k$(tmp_9, 2.0, EmployerTransactionsPage$render$lambda_3);
        var tmp_11 = Companion_instance_0;
        var tmp_12 = EmployerTransactionsPage$render$lambda_4;
        var tmp_13 = tmp_11.custom_k0krgj_k$(tmp_12, 1.0, EmployerTransactionsPage$render$lambda_5);
        var tmp_14 = Companion_instance_0;
        var tmp_15 = EmployerTransactionsPage$render$lambda_6;
        tableRecycler(tmp_2, tmp_3, tmp_4, [tmp_7, tmp_10, tmp_13, tmp_14.custom_k0krgj_k$(tmp_15, 0.5, EmployerTransactionsPage$render$lambda_7)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_5 = shownWhen(element, VOID, VOID, EmployerTransactionsPage$render$lambda_8);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_5.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_2);
        this_5.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_2);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'EmployerTransactionsPage', VOID, VOID, [Page()]);
    EmployerTransactionsPageClass = $;
  }
  return EmployerTransactionsPageClass;
}
var StrikeRowSemanticClass;
function StrikeRowSemantic() {
  if (StrikeRowSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        StrikeRowSemantic_instance = null;
        super('strikerow');
        StrikeRowSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), VOID, VOID, VOID, VOID, VOID, applyAlpha(theme.foreground_1, 0.25));
      }
      toString() {
        return 'StrikeRowSemantic';
      }
      hashCode() {
        return 324202431;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StrikeRowSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'StrikeRowSemantic');
    StrikeRowSemanticClass = $;
  }
  return StrikeRowSemanticClass;
}
var StrikeRowSemantic_instance;
function StrikeRowSemantic_getInstance() {
  if (StrikeRowSemantic_instance === VOID)
    new (StrikeRowSemantic())();
  return StrikeRowSemantic_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      *fetchAll_tffaak_k$(api, condition, $completion) {
        var transactions = yield* api.get_employerAccountTransaction_bpegb9_k$().query_o986pg_k$(new (Query())(condition, VOID, VOID, 2147483647), $completion);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(transactions, 10));
        var _iterator__ex2g4s = transactions.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = new (ID())(item.employer_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        var employerIds = toSet(destination);
        var tmp = api.get_employer_c2djlo_k$();
        var tmp2 = 2147483647;
        // Inline function 'com.lightningkite.services.database.Query' call
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
        var tmp$ret$6 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$6);
        var tmp$ret$7 = xDataClassPathInsideSet(get__id(it), employerIds);
        var tmp$ret$3 = new (Query())(tmp$ret$7, orderBy, 0, tmp2);
        // Inline function 'kotlin.collections.associate' call
        var this_0 = yield* tmp.query_o986pg_k$(tmp$ret$3, $completion);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(new (ID())(element._id_1), element.name_1);
          destination_0.put_4fpzoq_k$(pair.first_1, pair.second_1);
        }
        var employerNames = destination_0;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(transactions, 10));
        var _iterator__ex2g4s_1 = transactions.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp0_elvis_lhs = employerNames.get_wei43m_k$(new (ID())(item_0.employer_1));
          var tmp_1 = tmp0_elvis_lhs == null ? 'NOT FOUND' : tmp0_elvis_lhs;
          var tmp_2 = Cents__toDouble_impl_mg3etm(item_0.amount_1);
          var tmp1_safe_receiver = item_0.voided_1;
          var tmp_3 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.at_1;
          var tmp2_safe_receiver = item_0.voided_1;
          var tmp$ret$14 = new (EmployerTransactionCsvRow())(tmp_1, item_0.at_1, tmp_2, item_0.reason_1, item_0.pulledFrom_1, tmp_3, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.reason_1);
          destination_1.add_utx5q5_k$(tmp$ret$14);
        }
        return destination_1;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.employers.EmployerTransactionCsvRow', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('amount', false);
        tmp0_serialDesc.addElement_5pzumi_k$('reason', false);
        tmp0_serialDesc.addElement_5pzumi_k$('accountingReference', false);
        tmp0_serialDesc.addElement_5pzumi_k$('voidedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('voidReason', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_9hi8f8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.employer_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, InstantSerializer_getInstance(), value.at_1);
        tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 2, value.amount_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.reason_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, StringSerializer_getInstance(), value.accountingReference_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), value.voidedAt_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, StringSerializer_getInstance(), value.voidReason_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_9hi8f8_k$(encoder, value instanceof EmployerTransactionCsvRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0.0;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeDoubleElement_isei84_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeDoubleElement_isei84_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return EmployerTransactionCsvRow().new_org_thecommunitygroupinc_cares_views_employers_EmployerTransactionCsvRow_8wepes_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), InstantSerializer_getInstance(), DoubleSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var EmployerTransactionCsvRowClass;
function EmployerTransactionCsvRow() {
  if (EmployerTransactionCsvRowClass === VOID) {
    class $ {
      constructor(employer, at, amount, reason, accountingReference, voidedAt, voidReason) {
        this.employer_1 = employer;
        this.at_1 = at;
        this.amount_1 = amount;
        this.reason_1 = reason;
        this.accountingReference_1 = accountingReference;
        this.voidedAt_1 = voidedAt;
        this.voidReason_1 = voidReason;
      }
      toString() {
        return 'EmployerTransactionCsvRow(employer=' + this.employer_1 + ', at=' + this.at_1.toString() + ', amount=' + this.amount_1 + ', reason=' + this.reason_1 + ', accountingReference=' + this.accountingReference_1 + ', voidedAt=' + toString(this.voidedAt_1) + ', voidReason=' + this.voidReason_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.employer_1);
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + getNumberHashCode(this.amount_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.reason_1) | 0;
        result = imul(result, 31) + (this.accountingReference_1 == null ? 0 : getStringHashCode(this.accountingReference_1)) | 0;
        result = imul(result, 31) + (this.voidedAt_1 == null ? 0 : this.voidedAt_1.hashCode()) | 0;
        result = imul(result, 31) + (this.voidReason_1 == null ? 0 : getStringHashCode(this.voidReason_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmployerTransactionCsvRow()))
          return false;
        if (!(this.employer_1 === other.employer_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!equals(this.amount_1, other.amount_1))
          return false;
        if (!(this.reason_1 === other.reason_1))
          return false;
        if (!(this.accountingReference_1 == other.accountingReference_1))
          return false;
        if (!equals(this.voidedAt_1, other.voidedAt_1))
          return false;
        if (!(this.voidReason_1 == other.voidReason_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_employers_EmployerTransactionCsvRow_8wepes_k$(seen0, employer, at, amount, reason, accountingReference, voidedAt, voidReason, serializationConstructorMarker) {
        if (!(127 === (127 & seen0))) {
          throwMissingFieldException(seen0, 127, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.employer_1 = employer;
        $this.at_1 = at;
        $this.amount_1 = amount;
        $this.reason_1 = reason;
        $this.accountingReference_1 = accountingReference;
        $this.voidedAt_1 = voidedAt;
        $this.voidReason_1 = voidReason;
        return $this;
      }
    }
    initMetadataForClass($, 'EmployerTransactionCsvRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    EmployerTransactionCsvRowClass = $;
  }
  return EmployerTransactionCsvRowClass;
}
//region block: init
Companion_instance_1 = new (Companion())();
//endregion
//region block: exports
export {
  StrikeRowSemantic_getInstance as StrikeRowSemantic_getInstanceukyqkh22ym7,
  EmployerTransactionsPage as EmployerTransactionsPageanwqvpujplg1,
};
//endregion

//# sourceMappingURL=EmployerTransactionsPage.mjs.map
